// extracted by mini-css-extract-plugin
module.exports = {"header":"Expander_header__1XqA8","container":"Expander_container__3wCsD"};